//packages blocks
import moment from "moment";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import {
  Typography,
  CircularProgress,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TableBody,
  TableHead,
} from "@material-ui/core";
//common blocks
//styles, utils, assets and api blocks
import { BLACK, BLUE_EIGHT, WHITE } from "../../../../theme";
import { amountFormat } from "../../../../util/constants";
import { getStudentTransactions } from "../../../../api/student";
import { useTranslation } from "react-i18next";

export const PreviousTransactionsTable = ({ studentId }) => {
  const { t } = useTranslation();
  const [transactions, setTransactions] = useState([]);
  const { token } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const response = await getStudentTransactions(studentId, token);
      if (response.status) {
        setTransactions(response?.transactions);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);
  const history = useHistory();
  const onGetId = (id) => {
    history.push({
      pathname: `/transactions/${id}`,
      state: {
        transaction: transactions,
      },
    });
  };

  return (
    <div
      className="transactions-card transactions-card-student-section"
      style={{ maxWidth: "100%" }}
    >
      <div className="transaction-head">
        <Typography variant="h4" style={{ color: "black" }}>
          Recent Transactions
        </Typography>
      </div>
      <div
        style={{
          maxHeight: 400,
          marginTop: 20,
          overflowY: "auto",
        }}
      >
        {loading ? (
          <div
            style={{
              height: "400px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CircularProgress size={20} style={{ color: "black" }} />
            Fetching Transactions
          </div>
        ) : (
          <TableContainer style={{ marginTop: 5, border: "none !important" }}>
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: BLUE_EIGHT }}>
                  <TableCell
                    align="center"
                    style={{ color: "white", fontWeight: "bold" }}
                  >
                    {t("text_payee_id")}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ color: "white", fontWeight: "bold" }}
                  >
                    Amount
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ color: "white", fontWeight: "bold" }}
                  >
                    Date
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {transactions
                  ? transactions.map((e, i) => (
                      <>
                        {e.amount !== 0 ? (
                          <TableRow key={e.id}>
                            <TableCell
                              align="center"
                              style={{ color: "black" }}
                            >
                              {e?.student?.payeeType === "STUDENT"
                                ? e.student?.studentRegNo
                                : e.student?.parentRegNo}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ color: "black" }}
                            >
                              {amountFormat(e.amount)}
                            </TableCell>
                            <TableCell align="center">
                              {moment(e.createdAt).format("DD/MM/YYYY")}
                            </TableCell>
                            {/*<TableCell align="center">*/}
                            {/*  <i*/}
                            {/*    className="fas fa-arrow-right"*/}
                            {/*    style={{*/}
                            {/*      color: "white",*/}
                            {/*      background: "#04acdd",*/}
                            {/*      padding: 6,*/}
                            {/*      borderRadius: "50%",*/}
                            {/*      cursor: "pointer",*/}
                            {/*    }}*/}
                            {/*    onClick={() => onGetId(e.id)}*/}
                            {/*  ></i>*/}
                            {/*</TableCell>  todo: keep commented for now*/}
                          </TableRow>
                        ) : (
                          <></>
                        )}
                      </>
                    ))
                  : ""}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </div>
  );
};
